import router from '../../lib/router';
import session from '../../lib/session.js';
import APIClient from '../../state-charts/api-client';
import OrdersTable from '../../orders/ordersTable/OrdersTable.svelte';
import OrderDetails from '../../orders/orderDetails/OrderDetails.svelte';
import Boxy from '../../orders/newOrderForm/newOrderForm.svelte';
import PilotPoints from '../../pilotpoints';
import PublicProfile from '../../profiles/PublicProfile.svelte';
import Settings from '../../settings/Settings.svelte';
import SwitchService from '../../switch-service/SwitchService.svelte';
import Invite from '../../invite/Invite.svelte';
import OrdererPrivateTeams from '../../teams/OrdererPrivateTeams.svelte';
import WorkerTeams from '../../teams/WorkerTeams.svelte';
import Home from '../../Home.svelte';
import WorkerReport from '../../reports/WorkerReport.svelte';
import OrdererReport from '../../reports/OrdererReport.svelte';
import ChatPartners from '../../chat/ChatPartners.svelte';
import WorkersMap from '../../workers-map/WorkersMap.svelte';
import WorkerCV from '../../cv/WorkerCV.svelte';
import WorkerPublicCV from '../../cv/WorkerPublicCV.svelte';
import AuthMachine from '../../auth/AuthPage.svelte';
import Documents from '../../documents/Documents.svelte';
import PaymentReportsShell from '../../payment-and-reports/PaymentReportsShell.svelte';
import { debug } from '../../devtools';
import WP from '../../app-shell/state-store';

const local_route_map = {
  '/login': {
    component: AuthMachine,
    props: {
      query: null,
    },
  },
  '/order-new': {
    component: Boxy,
    props: {
      route_name: '/order-new',
    },
  },
  '/orders': {
    component: OrdersTable,
    props: {
      route_name: '/orders',
      query: null,
    },
  },
  '/settings': {
    component: Settings,
    props: {
      route_name: '/settings',
    },
  },
  '/cards': {
    component: PaymentReportsShell,
    props: {
      route_name: '/cards',
    },
  },
  '/profile': {
    component: PublicProfile,
    props: {
      route_name: '/profile',
      query: null,
    },
  },
  '/switch-service': {
    component: SwitchService,
    props: {
      route_name: '/switch-service',
      query: null,
    },
  },
  '/invite': {
    component: Invite,
    props: {
      route_name: '/invite',
    },
  },
  '/home': {
    component: Home,
    props: {
      route_name: '/home',
      query: null,
    },
  },
  '/pilot-points': {
    component: PilotPoints,
    props: {
      route_name: '/pilot-points',
      query: null,
    },
  },
  '/claim': {
    component: PilotPoints,
    props: {
      route_name: '/pilot-points',
      query: null,
    },
  },
  '/orderer-teams': {
    component: OrdererPrivateTeams,
    props: {
      route_name: '/orderer-teams',
    },
  },
  '/worker-teams': {
    component: WorkerTeams,
    props: {
      route_name: '/worker-teams',
    },
  },
  '/order-details': {
    component: OrderDetails,
    props: {
      route_name: '/order-details',
      query: null,
    },
  },
  '/worker-reports': {
    component: WorkerReport,
    props: {
      route_name: '/worker-reports',
    },
  },
  '/orderer-reports': {
    component: OrdererReport,
    props: {
      route_name: '/orderer-reports',
      query: null,
    },
  },
  '/workers-map': {
    component: WorkersMap,
    props: {
      route_name: '/workers-map',
    },
  },
  '/documents': {
    component: Documents,
    props: {
      route_name: '/documents',
      query: null,
    },
  },
  '/chats': {
    component: ChatPartners,
    props: {
      route_name: '/chats',
    },
  },
};

const check_auth = context => {
  if (context.path === '/login') {
    session.destroy();
    window.location.reload();
  }
  if (
    !APIClient.unauthorized_endpoints.includes(context.path) &&
    !session.value().token
  ) {
    window.location.pathname = '/login';
  }
};

const render_page = context => {
  check_auth(context);

  let path = !!context.path && context.path !== '/' ? context.path : '/home';
  let target = document.querySelector('#auth-app');
  let isCypress = document.querySelector('.aut-iframe');

  if (isCypress) {
    target = top.document
      .querySelector('.aut-iframe')
      .contentDocument.querySelector('#auth-app');
  }

  if (context.query && 'next' in context.query) {
    window.history.pushState(null, null, context.query.next);
    window.location.reload();
  }

  return render_local_page(target, path, context);
};

const render = (component, options) => {
  if (
    WP.current_view &&
    WP.current_view.$$ &&
    WP.current_view.$$.on_destroy &&
    Array.isArray(WP.current_view.$$.on_destroy)
  ) {
    WP.current_view.$$.on_destroy.map(f => f());
  }
  WP.current_view = new component(options);
};

const render_local_page = (target, path, context) => {
  const current = local_route_map[path];

  if (!current) return not_found(path, context);

  if (context.query && current.props.query !== undefined) {
    current.props.query = context.query;
  }

  target.innerHTML = '';

  render(current.component, {
    target: target,
    props: current.props,
  });
};

const render_cv_page = context => {
  check_auth(context);

  let target = top.document.querySelector('#auth-app');

  target.innerHTML = '';

  render(WorkerCV, {
    target: target,
    props: {
      route_name: '/cv',
      worker_id: context.params.worker_id,
    },
  });
};

const render_public_cv_page = context => {
  check_auth(context);

  let target = top.document.querySelector('#auth-app');

  target.innerHTML = '';

  render(WorkerPublicCV, {
    target: target,
    props: {
      route_name: '/cv',
      worker_id: context.params.worker_id,
    },
  });
};

const render_chat_page = context => {
  check_auth(context);

  let target = top.document.querySelector('#auth-app');

  target.innerHTML = '';

  render(ChatPartners, {
    target: target,
    props: {
      route_name: '/chats',
      external_order_uuid: context.params.order_uuid,
      external_partner: context.params.partner_id,
    },
  });
};

const render_chat_page_with_applicant = context => {
  check_auth(context);

  let target = top.document.querySelector('#auth-app');

  target.innerHTML = '';

  render(ChatPartners, {
    target: target,
    props: {
      route_name: '/chats',
      external_order_uuid: context.params.order_uuid,
      external_partner: context.params.partner_id,
      applicant_index: context.params.applicant_index,
    },
  });
};

const logout = async () => {
  try {
    await APIClient.submit_logout();
  } catch (e) {
    console.log(e);
  }
  session.destroy();
  window.location.pathname = '/login';
};

const not_found = path => {
  debug(`Page not found at ${path}.`);
  if (path === '/api') {
    window.location.href =
      'https://api-beta.workpilots.com/swagger-ui/index.html';
    return;
  }
  return router.navigate('/');
};

export const init_router = () => {
  router.add_routes([
    { path: '/chats/:order_uuid/partner/:partner_id', view: render_chat_page },
    {
      path: '/chats/:order_uuid/partner/:partner_id/index/:applicant_index',
      view: render_chat_page_with_applicant,
    },
    { path: '/logout', view: logout },
    { path: '/cv/:worker_id', view: render_cv_page },
    { path: '/cv/worker/:worker_id', view: render_public_cv_page },
    { path: '/(.*)?', view: render_page },
  ]);

  router.start();
};
